var _ellipse, _ellipse2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuePaymen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.56 0.56 54.32 51.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7163,
    cy: 26.5536,
    rx: 26.7163,
    ry: 25.5536,
    fill: "#F7F7F7",
    fillOpacity: 0.1,
    stroke: "#FF7676",
    strokeWidth: 0.8875
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7162,
    cy: 26.5533,
    rx: 23.6918,
    ry: 22.6607,
    fill: "#FF7676",
    fillOpacity: 0.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_14370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2048 19.667C21.1881 19.667 19.5381 21.317 19.5381 23.3337C19.5381 25.3503 21.1881 27.0003 23.2048 27.0003C25.2214 27.0003 26.8714 25.3503 26.8714 23.3337C26.8714 21.317 25.2214 19.667 23.2048 19.667ZM23.2048 25.167C22.1964 25.167 21.3714 24.342 21.3714 23.3337C21.3714 22.3253 22.1964 21.5003 23.2048 21.5003C24.2131 21.5003 25.0381 22.3253 25.0381 23.3337C25.0381 24.342 24.2131 25.167 23.2048 25.167ZM23.2048 28.8337C19.6298 28.8337 16.7881 30.4837 16.7881 32.5003V34.3337H26.8714V32.5003H18.6214C18.6214 31.9503 20.2714 30.667 23.2048 30.667C24.8548 30.667 26.1381 31.1253 26.8714 31.5837V29.567C25.8631 29.1087 24.5798 28.8337 23.2048 28.8337ZM36.9548 19.667H30.5381C29.5298 19.667 28.7048 20.492 28.7048 21.5003V32.5003C28.7048 33.5087 29.5298 34.3337 30.5381 34.3337H36.9548C37.9631 34.3337 38.7881 33.5087 38.7881 32.5003V21.5003C38.7881 20.492 37.9631 19.667 36.9548 19.667ZM31.4548 32.5003H30.5381V21.5003H31.4548V32.5003ZM36.9548 32.5003H33.2881V21.5003H36.9548V32.5003Z",
    fill: "#FF7676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_14370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(16.7881 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuePaymen);
export default __webpack_public_path__ + "static/media/duePaymen.f3c72668c8cc7f07e6d911702ce2ee4b.svg";
export { ForwardRef as ReactComponent };